$( document ).ready(function() {

    $("#menu-toggle").on( 'click', function(e) {
        e.preventDefault();
        $(".wrap").toggleClass("toggled");
    });

});
